import { render } from "./iconValue.vue?vue&type=template&id=e8d0013a"
import script from "./iconValue.vue?vue&type=script&lang=js"
export * from "./iconValue.vue?vue&type=script&lang=js"

import exportComponent from "/home/webiotcpc/dhruvi/Git/tivo/vue-tivo/tivo-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__